module.exports = __webpack_public_path__ + "static/service-3-d2a5d43dbca1744094390cb69ae186e8.jpg";